import React from 'react';

import type { Text } from '@zillow/constellation';
import {
  AdornedInput,
  Adornment,
  DatePicker,
  DatePickerInput,
  FormField,
  IconCalendarOutline,
  Label,
  Textarea,
} from '@zillow/constellation';

import type { Section } from '../../../models';
import { FIRE_ESCAPE } from '../../../constants';
import type { HTMLElementEvent } from '../../../models/Types';
import YesAndNoExpansion from '../../../../shared/components/Widgets/YesAndNoExpansion';
import { DATE_PICKER_FORMAT, DATE_PICKER_PLACEHOLDER } from '../../../constants/stringConstants';
import { disableFutureDates } from '../../../constants/functionConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function FireEscape({ section, setSectionValues }: Props) {
  function onNoFireEscape(): void {
    setSectionValues({ [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE]: false });
  }

  function onYesFireEscape(): void {
    setSectionValues({ [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE]: true });
  }

  function setFireEscapeLocationDescription(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_LOCATION]: event.currentTarget.value,
    });
  }

  function onFireEscapeServiceDateChange(date): void {
    setSectionValues({
      [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_SERVICE_DATE]: date,
    });
  }

  return (
    <FormField
      label={<Label size="lg">Are there fire escape(s) on the tenant’s floor?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesFireEscape}
          noHandler={onNoFireEscape}
          yesActive={section.getFieldValue(FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE)}
        >
          <FormField
            marginY="sm"
            label={<Label>Describe the location of the fire escape(s) on the tenant’s floor</Label>}
            control={
              <Textarea
                resize="vertical"
                onChange={setFireEscapeLocationDescription}
                value={section.getFieldValue(FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_LOCATION)}
              />
            }
          />
          <FormField
            label={<Label>Fire escape service date</Label>}
            control={
              <AdornedInput
                input={
                  <DatePickerInput
                    placeholder={DATE_PICKER_PLACEHOLDER}
                    value={section.getFieldValue(FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_SERVICE_DATE)}
                    onChange={onFireEscapeServiceDateChange}
                    datepicker={<DatePicker dateFormat={DATE_PICKER_FORMAT} disabledDates={disableFutureDates} />}
                  />
                }
                rightAdornment={
                  <Adornment>
                    <IconCalendarOutline />
                  </Adornment>
                }
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}

FireEscape.description = 'Asks about fire escape features within a building';

export default FireEscape;
